module.exports = __webpack_public_path__ + "static/media/charles06.a158fe59.jpg";